export enum TransactionStatus {
    pending = 'pending',
    error = 'error',
    waiting = 'waiting',
    minted = 'minted',
    canceled='canceled'
}
